import React from 'react';
import { Alert } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';

interface AlertProps {
  message: string;
}

// Use instead of the default antd `Alert` to keep icon consistency across the app.
const ErrorAlert: React.FC<AlertProps> = ({ message }) => {
  return (
    <Alert
      description={message}
      type="error"
      icon={<ExclamationCircleFilled />}
      showIcon
    />
  );
};

export default ErrorAlert;
